import { axios } from 'api/axios'
import { WX_AUTH_PUBLIC_APPID, WX_HOSTNAME } from 'common/utils/variables'

let wechat = (shareCfg, link) => {
  let params = {
    url: link,
    appId: WX_AUTH_PUBLIC_APPID
  }
  // if (appid) {
  //   params.appId = appid
  // }
  return axios
    .get(`${WX_HOSTNAME}/wx/page/createJsApiSignature`, { params })
    .then(res => {
      let response = res.data,
        suc = response.success,
        info = response.info,
        NOOP = function () { },
        data
      if (suc) {
        wx.config({
          debug: false,
          appId: response.data.appId, // 必填，公众号的唯一标识
          timestamp: response.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
          signature: response.data.signature, // 必填，签名，见附录1
          jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'],
          openTagList: ['wx-open-launch-app']
        })
        wx.ready(function () {
          console.log('wechat ready');
          console.log('shareCfg', shareCfg);
          wx.updateTimelineShareData({
            // debug: true,
            title: shareCfg.title, // 分享标题
            link: shareCfg.link, // 分享链接
            imgUrl: shareCfg.imgUrl, // 分享图标
            success: shareCfg.success || NOOP
          })
          wx.updateAppMessageShareData({
            // debug: true,
            title: shareCfg.title, // 分享标题
            desc: shareCfg.desc, // 分享描述
            link: shareCfg.link, // 分享链接
            imgUrl: shareCfg.imgUrl, // 分享图标
            success: shareCfg.success || NOOP
          })
        })
        wx.error(function (res) { })
      } else {
        console.log(info)
      }
    })
}

export default wechat
